// TODO - Type 'any' needs to be fixed.
/* eslint-disable no-mixed-spaces-and-tabs */
//import GigandTakeSwitch from "@gigandtake/switch";
import AddIcon from "@mui/icons-material/Add";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import {
	Autocomplete,
	Checkbox,
	CircularProgress,
	IconButton,
	InputAdornment,
	Select,
	TextField as Text,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Snackbar from "@mui/material/Snackbar";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import {
	DateTimePicker,
	LocalizationProvider,
} from "@mui/x-date-pickers-pro-6";
import { AdapterDayjs } from "@mui/x-date-pickers-pro-6/AdapterDayjs";
import { differenceInHours, differenceInMinutes, format } from "date-fns";
import dayjs from "dayjs";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import React, {
	ReactNode,
	useCallback,
	useEffect,
	useMemo,
	useRef,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import {
	createDraftShiftAsync,
	fetchAllWorkcenters,
} from "../../../../../../export/scheduler";
import useRepeatHolidayPreview from "../../../../../components/holidays/controller/use-repeat-holiday-preview";
import CreateShiftHolidayAlert from "../../../../../components/holidays/ui/create-shift-holiday-alert";
import RepeatShiftHolidayAlert from "../../../../../components/holidays/ui/repeat-shift-holiday-alert";
import { resetMaxWorkersByLocationJob } from "../../../../../components/jobs/store/jobs-slice";
import { DEFAULT_SHIFT_TRANSPORT_TYPE } from "../../../../../components/transport/store/transport-types";
import ShiftTransportSelect, {
	ShiftTransportValue,
} from "../../../../../components/transport/ui/shift-transport-select";
import { colors } from "../../../../../config/colors";
import CutoffHoursInput from "../../../../../design/cutoff-hours-input";
import Toggle from "../../../../../design/toggle";
import JobColor from "../../../../../design/ui/job-color";
import {
	DEFAULT_CUTOFF_HOURS,
	formatCutoffHours,
	getAcceptanceCutoffTime,
} from "../../../../../utils/acceptance-cutoff";
import { useDateFnsLocale } from "../../../../../utils/date-locale";
import { isSingleDate } from "../../../../../utils/helpers";
import {
	getShiftPurposeDetailField,
	getShiftPurposeOptions,
} from "../../../../../utils/shift-purpose-detail-field";
import useViewport from "../../../../../utils/use-viewport";
import useTransportEnabled from "../../../../transport/controllers/use-transport-enabled";
import useSchedulerData from "../../../controllers/use-scheduler-data";
import {
	fetchFilterAndShiftData,
	resetCreateDraftShiftAsyncState,
} from "../../../store/scheduler-slice";
import { SchedulerWorkCenter } from "../../../store/types";
import ActionButtons from "./action-buttons";
// import AddNote from "./add-note";
import Approve from "./approve";
import useNewShiftDialog from "./controllers/use-create-new-shift-dialog";
import { UseNewShiftDialogForm } from "./controllers/use-create-new-shift-dialog-form";
import EndTimePicker from "./end-time-picker";
import RepeatShift from "./repeat-shift";
import SelectSkills from "./select-skills";
import { applyDefaultShiftDuration, setToNearestTime, useStyles } from "./utils";

const scrollBarStyles = {
	height: "100%",
	maxHeight: "65vh",
	width: "100%",
	overflowY: "auto",
	overflowX: "hidden",
	padding: "0px 45px",
	"&::-webkit-scrollbar": {
		width: "8px",
	},
	"&::-webkit-scrollbar-track": {
		background: "#f1f1f1",
	},
	"&::-webkit-scrollbar-thumb": {
		background: "#888",
		borderRadius: "4px",
	},
	"&::-webkit-scrollbar-thumb:hover": {
		background: "#555",
	},
	"&::-webkit-scrollbar-corner": {
		background: "transparent",
	},
	"&::-webkit-resizer": {
		background: "transparent",
	},
	"&::-webkit-scrollbar-button": {
		display: "none",
	},
};

const shiftDay: number = new Date().getDay();
const initDays: Record<number, boolean> = {
	0: false,
	1: false,
	2: false,
	3: false,
	4: false,
	5: false,
	6: false,
	[shiftDay]: true,
};
const tempInitialShiftDateTimeValues = {
	startTime: "2022-10-19T10:00",
	endTime: "2022-10-19T18:00",
	workCenterId: 1,
	jobId: "",
	numberOfWorkersNeeded: "1",
	locationId: "",
	repeatShift: false,
	repeatOn: { ...initDays },
	shiftSkills: [],
	hexColor: "",
	shiftNote: "",
	shiftPurposeId: 0,
	shiftPurposeDetail: "",
	allowPartialSignups: true,
	isFlexiSignupEnabled: false,
 minFlexiSignupHours: 1,
	isShiftAcceptanceCutoffEnabled: false,
	minHoursBeforeShiftStartToAccept: 0,
	isUrgent: false,
  allowedWorkerTypeIds: [] as number[],
  transportType: DEFAULT_SHIFT_TRANSPORT_TYPE as ShiftTransportValue,
};

interface FilledFormControlProps {
	children: ReactNode;
	customStyles?: Record<string, string | number>;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

const FilledFormControl = React.memo<FilledFormControlProps>(
	({ children, customStyles }) => {
		const classes = useStyles();
		return (
			<FormControl
				variant='filled'
				className={classes.formControlRoot}
				sx={{ 
          ...customStyles,
          "& .MuiFormHelperText-root": {
            whiteSpace: "normal",
            wordBreak: "break-word",
          }
        }}
			>
				{children}
			</FormControl>
		);
	}
);

FilledFormControl.displayName = "FilledFormControl";

type NewShiftDialogProps = {
	draftShiftDate: Date;
	handleClose: (() => void) | undefined;
	isShiftSwap?: boolean;
	requestComponent?: any;
	isShiftCoverage?: boolean | undefined;
};

const NewShiftDialogForm: React.FC<NewShiftDialogProps> = ({
	draftShiftDate,
	handleClose,
	isShiftSwap,
	requestComponent,
	isShiftCoverage,
}) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const dateLocale = useDateFnsLocale();
	const { width } = useViewport();
	const isTransportEnabled = useTransportEnabled();
	const [
		{
			schema,
			initialShiftDateTimeValues,
			filteredJobs,
			selectedDatesOfTheWeek,
			totalHours,
			totalMins,
			shiftType,
		},
		{
			isDisabled,
			calculateTotalHoursFromEndTime,
			calculateTotalHoursFromStartTime,
			calculateTotalHoursFromWorkers,
			handleWorkcenterChange,
			getNumberOfStaff,
			setSelectedDatesOfTheWeek,
			setTotalHours,
			setShiftType,
			setCurrentLocationId,
		},
	] = useNewShiftDialog({ draftShiftDate });

	const [
		,
		{
			onFormSubmit,
			onEndTimeChange,
			onStartTimeChange,
			getLocationWorkcenters,
		},
	] = UseNewShiftDialogForm({
		setToNearestTime,
		dispatch,
		createDraftShiftAsync,
		setSelectedDatesOfTheWeek,
		calculateTotalHoursFromEndTime,
		calculateTotalHoursFromStartTime,
		isShiftSwap,
	});

	const {
		formData,
		workerRequestMetaData,
		maxWorkersByJobLocation,
		fetchFilterAndShiftDataStatus,
		workcenters,
		filterAllWorkcenters,
		isShiftBySkillEnabled,
		defaultShiftsSkillLevel,
		allSkillLevels,
		fetchAllWorkcentersStatus,
		shiftPurposes,
		isShiftPurposeEnabled,
		createDraftShiftAsyncErrorMessage,
		createDraftShiftAsyncStatus,
		filterAllLocations,
		defaultShiftHourDuration,
		shiftWorkerTypeFilterEnabled,
		workerTypesForCreateShift: workerTypes,
		urgentShiftEnabledLocations,
	} = useSchedulerData();
	const locationWorkcenters =
		getLocationWorkcenters && getLocationWorkcenters(workcenters);

	// For the toolip for Shift By Skill
	const skillLevel = allSkillLevels.find(
		(s: any) => s.level === defaultShiftsSkillLevel
	);
	const levelName = skillLevel ? skillLevel.name : t("common_not-applicable");

	const memoizedShiftValues = useMemo(
		() => ({
			jobId: initialShiftDateTimeValues?.jobId,
			locationId: initialShiftDateTimeValues?.locationId,
			startTime: initialShiftDateTimeValues?.startTime,
			endTime: initialShiftDateTimeValues?.endTime,
			workCenterId: initialShiftDateTimeValues?.workCenterId,
			shiftSkills: initialShiftDateTimeValues?.shiftSkills,
			allowPartialSignups: initialShiftDateTimeValues?.allowPartialSignups,
			allowedWorkerTypeIds: initialShiftDateTimeValues?.allowedWorkerTypeIds,
		}),
		[initialShiftDateTimeValues]
	);

	// Add this ref to track the last values we used
	const lastCalledValues = useRef("");

	useEffect(() => {
		if (memoizedShiftValues && memoizedShiftValues.workCenterId) {
			// Create a string representation of current values
			const currentValues = JSON.stringify({
				jobId: memoizedShiftValues.jobId,
				locationId: memoizedShiftValues.locationId,
				workCenterId: memoizedShiftValues.workCenterId,
				startTime: memoizedShiftValues.startTime,
				endTime: memoizedShiftValues.endTime,
				shiftSkills: memoizedShiftValues.shiftSkills,
				allowPartialSignups: memoizedShiftValues.allowPartialSignups,
				allowedWorkerTypeIds: memoizedShiftValues.allowedWorkerTypeIds,
			});

			// Only call if values have changed
			if (currentValues !== lastCalledValues.current) {
				getNumberOfStaff(
					memoizedShiftValues.jobId,
					memoizedShiftValues.locationId,
					memoizedShiftValues.workCenterId,
					new Date(memoizedShiftValues.startTime).toISOString(),
					new Date(memoizedShiftValues.endTime).toISOString(),
					memoizedShiftValues.shiftSkills,
					memoizedShiftValues.allowPartialSignups,
					memoizedShiftValues.allowedWorkerTypeIds
				);
				lastCalledValues.current = currentValues;
			}
		}
	}, [getNumberOfStaff, memoizedShiftValues]);
	// This is to ensure API is called only when filterAllWorkcenters is not available
	// Which happen on page refresh
	useEffect(() => {
		if (
			fetchFilterAndShiftDataStatus === "idle" &&
			fetchAllWorkcentersStatus === "idle"
		) {
			dispatch(fetchAllWorkcenters());
			dispatch(fetchFilterAndShiftData());
		}
	}, [dispatch, fetchFilterAndShiftDataStatus, fetchAllWorkcentersStatus]);

	return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Formik
        initialValues={
          initialShiftDateTimeValues
            ? initialShiftDateTimeValues
            : tempInitialShiftDateTimeValues
        }
        validationSchema={schema}
        onSubmit={(values, actions) => {
          if (onFormSubmit) onFormSubmit(values, actions);
        }}
        enableReinitialize
      >
        {({ isValid, dirty, values, setFieldValue, setValues, validateForm, isSubmitting, errors }) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const prevWorkCenterIdRef = useRef(values.workCenterId);
          // Set once the supervisor touches the cutoff by hand, so the
          // resolution effect below stops overwriting their choice.
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const acceptanceCutoffTouchedRef = useRef(false);
          // Same idea for the end time: a Location-Workcenter change re-applies
          // the new location's default duration only while the supervisor has
          // not set an end time of their own. A click-and-drag on the calendar
          // is such a choice, so a dragged slot starts out already set.
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const endTimeTouchedRef = useRef(!isSingleDate(draftShiftDate));
          // Which repeats land on holidays; also blocks posting when skipping
          // them would leave nothing to create.
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const repeatHolidayPreview = useRepeatHolidayPreview(values);

          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (prevWorkCenterIdRef.current !== values.workCenterId) {
              setFieldValue("isFlexiSignupEnabled", false);
              setFieldValue("allowPartialSignups", false);
              setFieldValue("minFlexiSignupHours", 1);
              prevWorkCenterIdRef.current = values.workCenterId;
            }
          }, [values.workCenterId, setFieldValue]);

          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            const workcenter = filterAllWorkcenters?.find(
              (wc: SchedulerWorkCenter) =>
                wc.id === Number(values.workCenterId)
            );
            const location = filterAllLocations?.find(
              (l: { id: number }) => l.id === Number(values.locationId)
            );

            // Work Center not opted in: the row is hidden, so clear any value
            // carried over from a previously selected Work Center rather than
            // submitting a cutoff the supervisor can no longer see.
            if (!workcenter?.isShiftAcceptanceCutoffEnabled) {
              acceptanceCutoffTouchedRef.current = false;
              if (
                values.isShiftAcceptanceCutoffEnabled ||
                values.minHoursBeforeShiftStartToAccept
              ) {
                setFieldValue("isShiftAcceptanceCutoffEnabled", false);
                setFieldValue("minHoursBeforeShiftStartToAccept", 0);
              }
              return;
            }

            // The supervisor has set this by hand - re-resolving on a Work
            // Center change must not overwrite their choice.
            if (acceptanceCutoffTouchedRef.current) return;

            const resolved = location?.shiftAcceptanceCutoffMinHours ?? null;

            const nextEnabled = !!resolved;
            const nextHours = resolved ?? 0;
            if (
              values.isShiftAcceptanceCutoffEnabled !== nextEnabled ||
              values.minHoursBeforeShiftStartToAccept !== nextHours
            ) {
              setFieldValue("isShiftAcceptanceCutoffEnabled", nextEnabled);
              setFieldValue("minHoursBeforeShiftStartToAccept", nextHours);
            }
          }, [
            values.workCenterId,
            values.locationId,
            values.isShiftAcceptanceCutoffEnabled,
            values.minHoursBeforeShiftStartToAccept,
            setFieldValue,
          ]);

          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (values.workCenterId && filterAllWorkcenters) {
              const selectedWorkcenter = filterAllWorkcenters.find(
                (wc: SchedulerWorkCenter) => wc.id === values.workCenterId
              );
              if (selectedWorkcenter) {
                const isFlexiSupported = !!selectedWorkcenter.isFlexiSignupEnabled;
                const isPartialSupported = !!selectedWorkcenter.isPartialSignupEnabled;

                if (values.isFlexiSignupEnabled && !isFlexiSupported) {
                  setFieldValue("isFlexiSignupEnabled", false);
                }
                if (values.allowPartialSignups && !isPartialSupported) {
                  setFieldValue("allowPartialSignups", false);
                }
              }
            }
          }, [values.workCenterId, values.isFlexiSignupEnabled, values.allowPartialSignups, setFieldValue]);

          const shiftPurposeOptions = getShiftPurposeOptions(shiftPurposes);

          // Free-text detail the selected Shift Purpose asks for, configured
          // per Shift Purpose in GAT Admin.
          const shiftPurposeDetailField = getShiftPurposeDetailField(
            shiftPurposes,
            values.shiftPurposeId
          );

          return (
            <Form className={classes.formRoot}>
            <Box sx={scrollBarStyles} mt={0}>
              {isShiftSwap ? (
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    width: "100%",
                    borderBottom: isShiftCoverage
                      ? "1px solid #E0E0E0"
                      : "none",
                    marginBottom: isShiftCoverage ? "16px" : 0,
                  }}
                >
                  {requestComponent}
                </Box>
              ) : null}
              {!isShiftPurposeEnabled ||
              (isShiftSwap && !isShiftCoverage) ? null : (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexDirection={width < 600 ? "column" : "row"}
                  mt={isShiftSwap ? 2 : 0}
                >
                  <Box width={"100%"}>
                    <FilledFormControl>
                      <Field
                        component={TextField}
                        type="text"
                        select
                        variant="filled"
                        name="shiftPurposeId"
                        id="shiftPurposeId"
                        label={t("scheduler_shift-purpose")}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setFieldValue("shiftPurposeId", e.target.value);
                          setFieldValue("shiftPurposeDetail", "");
                        }}
                        helperText=" "
                        fullWidth
                        InputLabelProps={{
                          shrink: true, // Ensure the label shrinks properly
                        }}
                        SelectProps={{
                          displayEmpty: true,
                          renderValue: (value: any) => {
                            if (!value || value === "") {
                              return (
                                <Typography
                                  sx={{
                                    fontFamily: "Roboto",
                                    fontSize: "16px",
                                    color: "rgba(0, 0, 0, 0.6)",
                                  }}
                                >
                                  {t("scheduler_select-a-purpose")}
                                </Typography>
                              );
                            }
                            const selectedPurpose = shiftPurposeOptions[value];
                            return selectedPurpose ? selectedPurpose.name : "";
                          },
                        }}
                      >
                        {Object.values(shiftPurposeOptions)
                          .filter((purpose: any) => purpose.isActive)
                          .map((purpose: any) => (
                            <MenuItem
                              value={purpose.id}
                              key={`shift-purpose-${purpose.id}`}
                            >
                              {purpose.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FilledFormControl>
                    {shiftPurposeDetailField ? (
                      <>
                        <FilledFormControl>
                          <Field
                            component={TextField}
                            type="text"
                            variant="filled"
                            multiline
                            rows={2}
                            name="shiftPurposeDetail"
                            id="shiftPurposeDetail"
                            label={shiftPurposeDetailField.label}
                            required={shiftPurposeDetailField.isRequired}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              maxLength: shiftPurposeDetailField.maxLength,
                            }}
                            disabled={isSubmitting}
                            fullWidth
                          />
                        </FilledFormControl>
                        <Box display="flex" justifyContent="flex-end">
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: "400",
                              lineHeight: "19px",
                              fontFamily: "Roboto",
                              color: "#666666",
                            }}
                          >{`${(values.shiftPurposeDetail ?? "").length} / ${shiftPurposeDetailField.maxLength}`}</Typography>
                        </Box>
                      </>
                    ) : null}
                  </Box>
                </Box>
              )}
              {!isShiftSwap && !values.repeatShift ? (
                <CreateShiftHolidayAlert
                  startTime={values.startTime}
                  endTime={values.endTime}
                  locationId={values.locationId}
                />
              ) : null}
              {isShiftSwap && !isShiftCoverage ? null : (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexDirection={width < 600 ? "column" : "row"}
                  mb={2.5}
                  mt={isShiftSwap && !isShiftPurposeEnabled ? 2 : 0}
                >
                  <Box width={width < 600 ? "100%" : "48%"} mr={1}>
                    {/*<DateTimePicker*/}
                    {/*	label='Shift Start Time'*/}
                    {/*	value={values.startTime}*/}
                    {/*	onChange={(newValue: string) => {*/}
                    {/*		if (onStartTimeChange && getNumberOfStaff) {*/}
                    {/*			const formattedDate =*/}
                    {/*				dayjs(newValue).format("YYYY-MM-DDTHH:mm");*/}
                    {/*			onStartTimeChange(formattedDate, {*/}
                    {/*				setFieldValue,*/}
                    {/*				values,*/}
                    {/*			});*/}
                    {/*			getNumberOfStaff(*/}
                    {/*				values.jobId,*/}
                    {/*				values.locationId,*/}
                    {/*				values.workCenterId,*/}
                    {/*				new Date(formattedDate).toISOString(),*/}
                    {/*				new Date(values.endTime).toISOString(),*/}
                    {/*				values.shiftSkills,*/}
                    {/*				values.allowPartialSignups*/}
                    {/*			);*/}
                    {/*		}*/}
                    {/*	}}*/}
                    {/*	isError={errors.startTime ? true : false}*/}
                    {/*	helperText={errors.startTime ? errors.startTime : ""}*/}
                    {/*/>*/}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        label={t("scheduler_shift-start-time")}
                        value={
                          values.startTime
                            ? dayjs(values.startTime, "YYYY-MM-DDTHH:mm")
                            : null
                        }
                        format="MM/DD/YYYY, hh:mm A"
                        minutesStep={15}
                        onChange={(newValue: any) => {
                          if (onStartTimeChange && getNumberOfStaff) {
                            const formattedDate =
                              dayjs(newValue).format("YYYY-MM-DDTHH:mm");
                            onStartTimeChange(formattedDate, {
                              setFieldValue,
                              setValues,
                              values,
                            });
                            getNumberOfStaff(
                              values.jobId,
                              values.locationId,
                              values.workCenterId,
                              new Date(formattedDate).toISOString(),
                              new Date(values.endTime).toISOString(),
                              values.shiftSkills,
                              values.allowPartialSignups,
                              values.allowedWorkerTypeIds
                            );
                          }
                        }}
                        slotProps={{
                          textField: {
                            variant: "filled",
                            fullWidth: true,
                            InputLabelProps: {
                              shrink: true,
                            },
                            error: !!errors.startTime,
                            helperText: errors.startTime
                              ? errors.startTime
                              : "",
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                  <Box width={width < 600 ? "100%" : "48%"}>
                    {/*<EndTimePicker*/}
                    {/*	minShiftHourDuration={minShiftHourDuration}*/}
                    {/*	maxShiftHourDuration={maxShiftHourDuration}*/}
                    {/*	defaultShiftHourDuration={defaultShiftHourDuration}*/}
                    {/*	values={values}*/}
                    {/*	setFieldValue={setFieldValue}*/}
                    {/*	onChange={(newValue: any) => {*/}
                    {/*		if (onEndTimeChange && getNumberOfStaff) {*/}
                    {/*			const formattedDate =*/}
                    {/*				dayjs(newValue).format("YYYY-MM-DDTHH:mm");*/}
                    {/*			onEndTimeChange(formattedDate, {*/}
                    {/*				setFieldValue,*/}
                    {/*				values,*/}
                    {/*			});*/}
                    {/*			getNumberOfStaff(*/}
                    {/*				values.jobId,*/}
                    {/*				values.locationId,*/}
                    {/*				values.workCenterId,*/}
                    {/*				new Date(values.startTime).toISOString(),*/}
                    {/*				new Date(formattedDate).toISOString(),*/}
                    {/*				values.shiftSkills,*/}
                    {/*				values.allowPartialSignups*/}
                    {/*			);*/}
                    {/*		}*/}
                    {/*	}}*/}
                    {/*	errors={errors}*/}
                    {/*/>*/}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        label={t("scheduler_shift-end-time")}
                        value={
                          values.endTime
                            ? dayjs(values.endTime, "YYYY-MM-DDTHH:mm")
                            : null
                        }
                        format="MM/DD/YYYY, hh:mm A"
                        minutesStep={15}
                        onChange={(newValue: any) => {
                          if (onEndTimeChange && getNumberOfStaff) {
                            // From here on a Location-Workcenter change keeps
                            // this end time and only re-validates it.
                            endTimeTouchedRef.current = true;
                            const formattedDate =
                              dayjs(newValue).format("YYYY-MM-DDTHH:mm");
                            onEndTimeChange(formattedDate, {
                              setFieldValue,
                              setValues,
                              values,
                            });
                            getNumberOfStaff(
                              values.jobId,
                              values.locationId,
                              values.workCenterId,
                              new Date(values.startTime).toISOString(),
                              new Date(formattedDate).toISOString(),
                              values.shiftSkills,
                              values.allowPartialSignups,
                              values.allowedWorkerTypeIds
                            );
                          }
                        }}
                        slotProps={{
                          textField: {
                            variant: "filled",
                            fullWidth: true,
                            InputLabelProps: {
                              shrink: true,
                            },
                            error: !!errors.endTime,
                            helperText: errors.endTime ? errors.endTime : "",
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              )}

              {isShiftSwap && !isShiftCoverage ? null : (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexDirection={width < 600 ? "column" : "row"}
                >
                  <Box width={"100%"}>
                    <FilledFormControl>
                      <Field
                        component={TextField}
                        type="text"
                        select
                        variant="filled"
                        name="workCenterId"
                        id="workCenterId"
                        label={t("scheduler_location-work-center")}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const workCenterId = e.target.value;
                          let locationWorkcenter = locationWorkcenters?.find(
                            (lwc: any) => lwc.id === workCenterId
                          );
                          if (fetchFilterAndShiftDataStatus === "fulfilled") {
                            locationWorkcenter = filterAllWorkcenters?.find(
                              (workcenter: SchedulerWorkCenter) =>
                                workcenter.id === parseInt(workCenterId)
                            );
                          }
                          // Refresh the Job Role list behind the dropdown. The
                          // Job Role itself is cleared below, so nothing is
                          // auto-selected here.
                          if (handleWorkcenterChange) {
                            handleWorkcenterChange(workCenterId, null);
                          }

                          // One setValues rather than a run of setFieldValue
                          // calls: each setFieldValue revalidates with only its
                          // own field patched, so the duration limits would be
                          // checked against the Location being replaced.
                          const nextValues = {
                            ...values,
                            workCenterId,
                          } as typeof values;
                          if (locationWorkcenter) {
                            nextValues.locationId =
                              locationWorkcenter.locationId;
                            nextValues.jobId = "";
                            nextValues.hexColor = "";
                            setCurrentLocationId(
                              locationWorkcenter?.locationId
                            );
                          }
                          const nextLocation = filterAllLocations?.find(
                            (location: { id: number }) =>
                              location.id === Number(nextValues.locationId)
                          );
                          // The new location's default duration decides the end
                          // time, the same rule the dialog opened with - unless
                          // the supervisor has already set one by hand.
                          if (
                            !endTimeTouchedRef.current &&
                            nextValues.startTime
                          ) {
                            nextValues.endTime = applyDefaultShiftDuration(
                              nextValues.startTime,
                              nextLocation?.defaultShiftDuration ??
                                defaultShiftHourDuration
                            );
                          }
                          if (
                            nextValues.allowPartialSignups &&
                            !nextLocation?.isPartialSignupEnabled
                          ) {
                            nextValues.allowPartialSignups = false;
                          }
                          setValues(nextValues);
                        }}
                        helperText=" "
                        fullWidth
                      >
                        {fetchFilterAndShiftDataStatus === "fulfilled" &&
                        filterAllWorkcenters
                          ? filterAllWorkcenters.map(
                              (workcenter: SchedulerWorkCenter) => (
                                <MenuItem
                                  value={`${workcenter.id}`}
                                  key={`workcenter-${workcenter.id}`}
                                  id={`${workcenter.id}`}
                                >
                                  {workcenter.nameWithLocation}
                                </MenuItem>
                              )
                            )
                          : locationWorkcenters &&
                            locationWorkcenters.map((lwc: any) => (
                              <MenuItem value={lwc.id} key={lwc.id} id={lwc.id}>
                                {lwc.locationName} - {lwc.name}
                              </MenuItem>
                            ))}
                      </Field>
                    </FilledFormControl>
                  </Box>
                </Box>
              )}

              {isShiftSwap && !isShiftCoverage ? null : (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexDirection={width < 600 ? "column" : "row"}
                  mb={0}
                >
                  <Box width={width < 600 ? "100%" : "48%"} mr={1}>
                    <FilledFormControl>
                      <Field
                        component={TextField}
                        type="text"
                        variant="filled"
                        name="numberOfWorkersNeeded"
                        id="numberOfWorkersNeeded"
                        label={t("scheduler_required-workers")}
                        disabled={isSubmitting}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const rawValue = e.target.value;
                          // Only allow empty or digits (no decimals, no negatives)
                          if (rawValue === "" || /^[0-9]+$/.test(rawValue)) {
                            setFieldValue("numberOfWorkersNeeded", rawValue);
                            if (calculateTotalHoursFromWorkers) {
                              calculateTotalHoursFromWorkers(values, rawValue);
                            }
                          }
                        }}
                      />
                    </FilledFormControl>
                  </Box>
                  <Box width={width < 600 ? "100%" : "48%"}>
                    <FilledFormControl>
                      <Field
                        component={TextField}
                        disabled
                        value={
                          totalHours !== undefined && totalMins !== undefined
                            ? `${totalHours <= 0 ? 0 : totalHours} ${t(
                                "scheduler_hours-label"
                              )} ${totalMins <= 0 ? 0 : totalMins} ${t(
                                "scheduler_minutes-label"
                              )}`
                            : ""
                        }
                        type="text"
                        variant="filled"
                        label={t("scheduler_total-hours")}
                        name="total-hours"
                      />
                    </FilledFormControl>
                  </Box>
                </Box>
              )}
              {(isShiftSwap && !isShiftCoverage) ||
              !isShiftBySkillEnabled ? null : (
                <Box mt={3} mb={1}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "24px",
                      fontFamily: "Roboto",
                    }}
                  >
                    {t("scheduler_shift-type-find-workers")}
                  </Typography>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={shiftType}
                      onChange={(e) => {
                        if (e.target.value === "skills") {
                          setFieldValue("jobId", "");
                        } else {
                          if (filteredJobs.length === 1) {
                            setFieldValue("jobId", filteredJobs[0].id);
                          }
                          setFieldValue("shiftSkills", []);
                        }
                        setShiftType(e.target.value);
                      }}
                      sx={{ display: "flex", flexDirection: "row" }}
                    >
                      <FormControlLabel
                        value="jobs"
                        control={<Radio />}
                        label={t("scheduler_job-role")}
                      />
                      <FormControlLabel
                        value="skills"
                        control={<Radio />}
                        label={t("scheduler_skills")}
                      />
                    </RadioGroup>
                    {shiftType === "skills" ? (
                      <Tooltip
                        // title='All default skill levels are set in the Admin section'
                        title={t("scheduler_skill-competency-tooltip", {
                          level: levelName,
                        })}
                        arrow
                        slotProps={{
                          popper: {
                            sx: {
                              [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                                {
                                  width: "150px",
                                },
                            },
                          },
                        }}
                      >
                        <InfoOutlinedIcon />
                      </Tooltip>
                    ) : null}
                  </FormControl>
                </Box>
              )}
              {shiftType === "skills" && isShiftBySkillEnabled ? (
                <SelectSkills
                  values={values}
                  setFieldValue={setFieldValue}
                  getNumberOfStaff={getNumberOfStaff}
                  resetMaxWorkersByLocationJob={() =>
                    dispatch(resetMaxWorkersByLocationJob())
                  }
                />
              ) : isShiftSwap && !isShiftCoverage ? null : (
                <Box width={"100%"} mt={isShiftBySkillEnabled ? 0 : 2.5}>
                  <FilledFormControl>
                    <Autocomplete
                      options={filteredJobs ?? []}
                      getOptionLabel={(option) => option.name}
                      disabled={filteredJobs?.length === 0}
                      value={
                        filteredJobs?.find(
                          (job: any) => job.id === values.jobId
                        ) ??
                        (filteredJobs?.length === 1 && values.jobId !== ""
                          ? filteredJobs[0]
                          : null)
                      }
                      onChange={(e, newValue) => {
                        dispatch(resetMaxWorkersByLocationJob());
                        let locationWorkcenter = locationWorkcenters?.find(
                          (lwc: any) => lwc.id === values.workCenterId
                        );
                        if (fetchFilterAndShiftDataStatus === "fulfilled") {
                          locationWorkcenter = filterAllWorkcenters?.find(
                            (workcenter: SchedulerWorkCenter) =>
                              workcenter.id ===
                              parseInt(String(values.workCenterId))
                          );
                        }
                        if (locationWorkcenter && getNumberOfStaff) {
                          setFieldValue(
                            "locationId",
                            locationWorkcenter?.locationId
                          );
                          getNumberOfStaff(
                            newValue?.id ?? "",
                            locationWorkcenter.locationId,
                            values.workCenterId,
                            new Date(values.startTime).toISOString(),
                            new Date(values.endTime).toISOString(),
                            [],
                            values.allowPartialSignups,
                            values.allowedWorkerTypeIds
                          );
                        }
                        setFieldValue("jobId", newValue?.id ?? "");
                        setFieldValue("hexColor", newValue?.hexColor ?? "");
                      }}
                      renderInput={(params) => {
                        return (
                          <Text
                            {...params}
                            variant="filled"
                            label={t("scheduler_job-role")}
                            disabled={filteredJobs?.length === 0}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: values.jobId && (
                                <JobColor color={`#${values.hexColor ?? ""}`} />
                              ),
                            }}
                          />
                        );
                      }}
                      renderOption={(props, option) => {
                        const { key, ...otherProps } = props;
                        return (
                          <Box
                            key={key}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "5px",
                            }}
                            component={"li"}
                            {...otherProps}
                          >
                            <JobColor color={`#${option.hexColor}`} />
                            <Typography>{option.name}</Typography>
                          </Box>
                        );
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        marginTop: "2px",
                        color:
                          maxWorkersByJobLocation.data === 0 ? "red" : "auto",
                      }}
                    >
                      {maxWorkersByJobLocation.status === "pending" ? (
                        <CircularProgress size={20} />
                      ) : maxWorkersByJobLocation.status === "fulfilled" &&
                        values.jobId ? (
                        // " worker(s) have this job"
                        t("scheduler_workers-found", {
                          count: maxWorkersByJobLocation.data,
                        })
                      ) : (
                        ""
                      )}
                    </Typography>
                  </FilledFormControl>
                </Box>
              )}

              {shiftWorkerTypeFilterEnabled &&
                workerTypes.length > 0 &&
                !(isShiftSwap && !isShiftCoverage) && (
                  <Box width="100%" mt={2}>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      options={workerTypes}
                      getOptionLabel={(option: any) => option.name}
                      value={
                        values.allowedWorkerTypeIds === null
                          ? workerTypes
                          : workerTypes.filter((wt: any) =>
                              values.allowedWorkerTypeIds?.includes(wt.id)
                            )
                      }
                      onChange={(_: any, selected: any[]) => {
                        const next =
                          selected.length === workerTypes.length
                            ? null
                            : selected.map((wt: any) => wt.id);
                        setFieldValue("allowedWorkerTypeIds", next);
                        if (getNumberOfStaff) {
                          const startTimeISO = new Date(
                            values.startTime
                          ).toISOString();
                          const endTimeISO = new Date(
                            values.endTime
                          ).toISOString();
                          getNumberOfStaff(
                            shiftType === "skills" ? null : values.jobId,
                            values.locationId,
                            values.workCenterId,
                            startTimeISO,
                            endTimeISO,
                            shiftType === "skills" ? values.shiftSkills : [],
                            values.allowPartialSignups,
                            next
                          );
                        }
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox checked={selected} sx={{ mr: 1 }} />
                          {option.name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <Text
                          {...params}
                          variant="filled"
                          label={t("scheduler_allowed-worker-types")}
                        />
                      )}
                    />
                  </Box>
                )}

              {isShiftSwap && !isShiftCoverage ? null : (
                <Box width={"100%"} mr={1} mt={2} mb={2}>
                  <FilledFormControl>
                    <Text
                      type="text"
                      variant="filled"
                      name="note"
                      id="note"
                      label={t("scheduler_note-to-workers")}
                      InputLabelProps={{ shrink: true }}
                      placeholder={t("scheduler_note-placeholder")}
                      multiline
                      rows={2}
                      disabled={isSubmitting}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setFieldValue("shiftNote", e.target.value);
                      }}
                      error={values.shiftNote.length > 250}
                      helperText={
                        values.shiftNote.length > 250
                          ? t("scheduler_note-max-length")
                          : ""
                      }
                    />
                  </FilledFormControl>
                  <Box display="flex" justifyContent="flex-end">
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "19px",
                        fontFamily: "Roboto",
                        color: "#666666",
                      }}
                    >{`${values.shiftNote.length} / 250`}</Typography>
                  </Box>
                </Box>
              )}

              {!isTransportEnabled ||
              (isShiftSwap && !isShiftCoverage) ? null : (
                <Box width="100%" mt={2} mb={1}>
                  <ShiftTransportSelect
                    value={values.transportType}
                    onChange={(code) => setFieldValue("transportType", code)}
                    disabled={isSubmitting}
                  />
                </Box>
              )}

              {isShiftSwap && !isShiftCoverage
                ? null
                : urgentShiftEnabledLocations?.includes(
                    Number(values.locationId)
                  ) && (
                    <Box width="100%" mt={2} mb={2}>
                      <Box display="flex" alignItems="center">
                        <Toggle
                          name="isUrgent"
                          id="isUrgent"
                          onChange={() =>
                            setFieldValue("isUrgent", !values.isUrgent)
                          }
                        />
                        <Box display="flex" flexDirection="column" ml={2}>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "Roboto",
                              fontWeight: 400,
                              letterSpacing: "0.15px",
                              color: "#000000DE",
                            }}
                          >
                            {t("scheduler_mark-as-urgent")}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontFamily: "Roboto",
                              fontWeight: 400,
                              letterSpacing: "0.4px",
                              color: "#00000099",
                            }}
                          >
                            {t("scheduler_urgent-notifications-info")}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}

              {(() => {
                // Signup flexibility only applies to a shift being posted.
                if (isShiftSwap && !isShiftCoverage) return null;

                // Check if partial signups should be disabled
                const selectedWorkcenter = filterAllWorkcenters?.find(
                  (workcenter: SchedulerWorkCenter) =>
                    workcenter.id === Number(values.workCenterId)
                );

                const selectedLocation = filterAllLocations?.find(
                  (location: { id: number }) =>
                    location.id === Number(values.locationId)
                );

                const shiftDuration =
                  differenceInMinutes(
                    new Date(values.endTime),
                    new Date(values.startTime)
                  ) / 60;

                const isPartialSignupVisible =
                  values.workCenterId &&
                  (selectedWorkcenter?.isPartialSignupEnabled || (selectedWorkcenter as any)?.IsPartialSignupEnabled);

                const isPartialSignupDisabled = values.isFlexiSignupEnabled;

                const isFlexiSignupVisible =
                  values.workCenterId &&
                  (selectedWorkcenter?.isFlexiSignupEnabled || (selectedWorkcenter as any)?.IsFlexiSignupEnabled);

                const isFlexiSignupDisabled = values.allowPartialSignups;

                if (!isPartialSignupVisible && !isFlexiSignupVisible)
                  return null;

                return (
                  <Box width="100%" mt={2}>
                    <Box display="flex" alignItems="center">
                      <Toggle
                        name="allowFlexibleSignups"
                        id="allowFlexibleSignups"
                        checked={values.allowPartialSignups || values.isFlexiSignupEnabled}
                        onChange={() => {
                          const isCurrentlyEnabled = values.allowPartialSignups || values.isFlexiSignupEnabled;
                          if (isCurrentlyEnabled) {
                            const newValues = {
                              ...values,
                              allowPartialSignups: false,
                              isFlexiSignupEnabled: false,
                            };
                            setValues(newValues);
                            if (getNumberOfStaff) {
                              getNumberOfStaff(
                                shiftType === "skills" ? null : values.jobId,
                                values.locationId,
                                values.workCenterId,
                                new Date(values.startTime).toISOString(),
                                new Date(values.endTime).toISOString(),
                                shiftType === "skills" ? values.shiftSkills : [],
                                false,
                                values.allowedWorkerTypeIds
                              );
                            }
                          } else {
                            if (isPartialSignupVisible) {
                              const newValues = {
                                ...values,
                                allowPartialSignups: true,
                                isFlexiSignupEnabled: false,
                              };
                              setValues(newValues);
                              if (getNumberOfStaff) {
                                getNumberOfStaff(
                                  shiftType === "skills" ? null : values.jobId,
                                  values.locationId,
                                  values.workCenterId,
                                  new Date(values.startTime).toISOString(),
                                  new Date(values.endTime).toISOString(),
                                  shiftType === "skills" ? values.shiftSkills : [],
                                  true,
                                  values.allowedWorkerTypeIds
                                );
                              }
                            } else if (isFlexiSignupVisible) {
                              setValues({
                                ...values,
                                allowPartialSignups: false,
                                isFlexiSignupEnabled: true,
                                minFlexiSignupHours: values.minFlexiSignupHours || selectedLocation?.flexiShiftMinHours || 1,
                              });
                            }
                          }
                          setTimeout(() => validateForm(), 0);
                        }}
                      />
                      <Box display="flex" flexDirection="column" ml={2}>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            letterSpacing: "0.15px",
                            color: "#000000DE",
                          }}
                        >
                          {t("scheduler_allow-flexible-signups")}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            letterSpacing: "0.4px",
                            color: "#00000099",
                          }}
                        >
                          {t("scheduler_flexible-signups-desc")}
                        </Typography>
                      </Box>
                    </Box>

                    {(values.allowPartialSignups || values.isFlexiSignupEnabled) && (
                      <Box mt={2} ml={1}>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontFamily: "Roboto",
                            fontWeight: 500,
                            color: "#000000DE",
                            mb: 1,
                          }}
                        >
                          {t("scheduler_signup-flexibility")}
                        </Typography>
                        
                        {isPartialSignupVisible && isFlexiSignupVisible ? (
                          <RadioGroup
                            value={values.allowPartialSignups ? "half" : "custom"}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "half") {
                                const newValues = {
                                  ...values,
                                  allowPartialSignups: true,
                                  isFlexiSignupEnabled: false,
                                };
                                setValues(newValues);
                                if (getNumberOfStaff) {
                                  getNumberOfStaff(
                                    shiftType === "skills" ? null : values.jobId,
                                    values.locationId,
                                    values.workCenterId,
                                    new Date(values.startTime).toISOString(),
                                    new Date(values.endTime).toISOString(),
                                    shiftType === "skills" ? values.shiftSkills : [],
                                    true,
                                    values.allowedWorkerTypeIds
                                  );
                                }
                              } else {
                                const newValues = {
                                  ...values,
                                  allowPartialSignups: false,
                                  isFlexiSignupEnabled: true,
                                  minFlexiSignupHours: Math.max(values.minFlexiSignupHours || 0, 1),
                                };
                                setValues(newValues);
                                if (getNumberOfStaff) {
                                  getNumberOfStaff(
                                    shiftType === "skills" ? null : values.jobId,
                                    values.locationId,
                                    values.workCenterId,
                                    new Date(values.startTime).toISOString(),
                                    new Date(values.endTime).toISOString(),
                                    shiftType === "skills" ? values.shiftSkills : [],
                                    false,
                                    values.allowedWorkerTypeIds
                                  );
                                }
                              }
                              setTimeout(() => validateForm(), 0);
                            }}
                          >
                            <Box
                              sx={{
                                border: "1px solid #E0E0E0",
                                borderRadius: "8px",
                                p: 1.5,
                                mb: 1,
                                backgroundColor: values.allowPartialSignups ? "#F4F7FE" : "transparent",
                              }}
                            >
                              <FormControlLabel
                                value="half"
                                control={<Radio size="small" disabled={shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0)} />}
                                label={
                                  <Box>
                                    <Typography sx={{ fontSize: "14px", fontWeight: 500, color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "inherit" }}>{t("scheduler_half-shift-min-duration", { count: selectedLocation?.partialShiftMinHours ?? 0, unit: (selectedLocation?.partialShiftMinHours ?? 0) !== 1 ? t("scheduler_hours-unit") : t("scheduler_hour-unit") })}</Typography>
                                    <Typography sx={{ fontSize: "12px", color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "#00000099" }}>
                                      {t("scheduler_half-shift-desc")}
                                    </Typography>
                                    <Box display="flex" gap={1} mt={1}>
                                      <Box sx={{ px: 1, py: 0.5, bgcolor: "#E0E0E0", borderRadius: "4px", fontSize: "10px", fontWeight: 700, color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "inherit" }}>{t("scheduler_first-half")}</Box>
                                      <Box sx={{ px: 1, py: 0.5, bgcolor: "#E0E0E0", borderRadius: "4px", fontSize: "10px", fontWeight: 700, color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "inherit" }}>{t("scheduler_second-half")}</Box>
                                    </Box>
                                  </Box>
                                }
                                sx={{ alignItems: "flex-start", m: 0 }}
                              />
                            </Box>

                            <Box
                              sx={{
                                border: "1px solid #E0E0E0",
                                borderRadius: "8px",
                                p: 1.5,
                                backgroundColor: values.isFlexiSignupEnabled ? "#F4F7FE" : "transparent",
                              }}
                            >
                              <FormControlLabel
                                value="custom"
                                control={<Radio size="small" disabled={shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1)} />}
                                label={
                                  <Box width="100%">
                                    <Typography sx={{ fontSize: "14px", fontWeight: 500, color: shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1) ? "#bdbdbd" : "inherit" }}>{t("scheduler_custom-duration-min-duration", { count: selectedLocation?.flexiShiftMinHours ?? 1, unit: (selectedLocation?.flexiShiftMinHours ?? 1) > 1 ? t("scheduler_hours-unit") : t("scheduler_hour-unit") })}</Typography>
                                    <Typography sx={{ fontSize: "12px", color: shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1) ? "#bdbdbd" : "#00000099" }}>
                                      {t("scheduler_custom-duration-desc")}
                                    </Typography>
                                    {values.isFlexiSignupEnabled && (
                                      <Box mt={2} width="100%">
                                        <FilledFormControl customStyles={{ width: "260px", minWidth: "260px", maxWidth: "260px" }}>
                                          <Field
                                            component={TextField}
                                            type="number"
                                            variant="filled"
                                            name="minFlexiSignupHours"
                                            label={t("scheduler_minimum-signup-duration")}
                                            onKeyDown={(e) => {
                                              if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start" sx={{ mt: "16px !important" }}>
                                                  <IconButton
                                                    size="small"
                                                    disabled={values.minFlexiSignupHours <= 1}
                                                    onClick={() => {
                                                      const minHours = 1;
                                                      const currentValue = values.minFlexiSignupHours || minHours;
                                                      setFieldValue("minFlexiSignupHours", Math.max(minHours, currentValue - 1));
                                                    }}
                                                  >
                                                    <RemoveIcon />
                                                  </IconButton>
                                                </InputAdornment>
                                              ),
                                              endAdornment: (
                                                <InputAdornment position="end" sx={{ mt: "16px !important" }}>
                                                  <Box display="flex" alignItems="center">
                                                    <Typography sx={{ mr: 1, fontSize: "14px" }}>{t(values.minFlexiSignupHours > 1 ? "scheduler_hours-unit" : "scheduler_hour-unit")}</Typography>
                                                    <IconButton
                                                      size="small"
                                                      disabled={values.minFlexiSignupHours + 1 >= shiftDuration}
                                                      onClick={() => {
                                                        const currentValue = values.minFlexiSignupHours || 1;
                                                        setFieldValue("minFlexiSignupHours", currentValue + 1);
                                                      }}
                                                    >
                                                      <AddIcon />
                                                    </IconButton>
                                                  </Box>
                                                </InputAdornment>
                                              ),
                                            }}
                                            inputProps={{
                                              step: 1,
                                              min: 1,
                                              style: { textAlign: "center" },
                                            }}
                                            value={values.minFlexiSignupHours}
                                            helperText={errors.minFlexiSignupHours}
                                            error={!!errors.minFlexiSignupHours}
                                          />
                                        </FilledFormControl>
                                      </Box>
                                    )}
                                  </Box>
                                }
                                sx={{ alignItems: "flex-start", m: 0, width: "100%" }}
                              />
                            </Box>
                          </RadioGroup>
                        ) : (
                          <Box
                            sx={{
                              border: "1px solid #E0E0E0",
                              borderRadius: "8px",
                              p: 1.5,
                              backgroundColor: "#F4F7FE",
                            }}
                          >
                            {isPartialSignupVisible ? (
                              <Box>
                                <Typography sx={{ fontSize: "14px", fontWeight: 500, color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "inherit" }}>{t("scheduler_half-shift-min-duration", { count: selectedLocation?.partialShiftMinHours ?? 0, unit: (selectedLocation?.partialShiftMinHours ?? 0) !== 1 ? t("scheduler_hours-unit") : t("scheduler_hour-unit") })}</Typography>
                                <Typography sx={{ fontSize: "12px", color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "#00000099" }}>
                                  {t("scheduler_half-shift-desc")}
                                </Typography>
                                <Box display="flex" gap={1} mt={1}>
                                  <Box sx={{ px: 1, py: 0.5, bgcolor: "#E0E0E0", borderRadius: "4px", fontSize: "10px", fontWeight: 700, color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "inherit" }}>{t("scheduler_first-half")}</Box>
                                  <Box sx={{ px: 1, py: 0.5, bgcolor: "#E0E0E0", borderRadius: "4px", fontSize: "10px", fontWeight: 700, color: shiftDuration < (selectedLocation?.partialShiftMinHours ?? 0) ? "#bdbdbd" : "inherit" }}>{t("scheduler_second-half")}</Box>
                                </Box>
                              </Box>
                            ) : (
                              <Box width="100%">
                                <Typography sx={{ fontSize: "14px", fontWeight: 500, color: shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1) ? "#bdbdbd" : "inherit" }}>{t("scheduler_custom-duration-min-duration", { count: selectedLocation?.flexiShiftMinHours ?? 1, unit: (selectedLocation?.flexiShiftMinHours ?? 1) > 1 ? t("scheduler_hours-unit") : t("scheduler_hour-unit") })}</Typography>
                                <Typography sx={{ fontSize: "12px", color: shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1) ? "#bdbdbd" : "#00000099" }}>
                                  {t("scheduler_custom-duration-desc")}
                                </Typography>
                                <Box mt={2} width="100%">
                                  <FilledFormControl customStyles={{ width: "260px", minWidth: "260px", maxWidth: "260px" }}>
                                    <Field
                                      component={TextField}
                                      type="number"
                                      variant="filled"
                                      name="minFlexiSignupHours"
                                      label={t("scheduler_minimum-signup-duration")}
                                      onKeyDown={(e) => {
                                        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      disabled={shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1)}
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start" sx={{ mt: "16px !important" }}>
                                            <IconButton
                                              size="small"
                                              disabled={shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1) || values.minFlexiSignupHours <= 1}
                                              onClick={() => {
                                                const minHours = 1;
                                                const currentValue = values.minFlexiSignupHours || minHours;
                                                setFieldValue("minFlexiSignupHours", Math.max(minHours, currentValue - 1));
                                              }}
                                            >
                                              <RemoveIcon />
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                        endAdornment: (
                                          <InputAdornment position="end" sx={{ mt: "16px !important" }}>
                                            <Box display="flex" alignItems="center">
                                              <Typography sx={{ mr: 1, fontSize: "14px", color: shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1) ? "#bdbdbd" : "inherit" }}>{t(values.minFlexiSignupHours > 1 ? "scheduler_hours-unit" : "scheduler_hour-unit")}</Typography>
                                              <IconButton
                                                size="small"
                                                disabled={shiftDuration < (selectedLocation?.flexiShiftMinHours ?? 1) || values.minFlexiSignupHours + 1 >= shiftDuration}
                                                onClick={() => {
                                                  const currentValue = values.minFlexiSignupHours || 1;
                                                  setFieldValue("minFlexiSignupHours", currentValue + 1);
                                                }}
                                              >
                                                <AddIcon />
                                              </IconButton>
                                            </Box>
                                          </InputAdornment>
                                        ),
                                      }}
                                      inputProps={{
                                        step: 1,
                                        min: 1,
                                        style: { textAlign: "center" },
                                      }}
                                      value={values.minFlexiSignupHours}
                                      helperText={errors.minFlexiSignupHours}
                                      error={!!errors.minFlexiSignupHours}
                                    />
                                  </FilledFormControl>
                                </Box>
                              </Box>
                            )}
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                );
              })()}

              {(() => {
                const selectedWorkcenter = filterAllWorkcenters?.find(
                  (workcenter: SchedulerWorkCenter) =>
                    workcenter.id === Number(values.workCenterId)
                );

                const selectedLocation = filterAllLocations?.find(
                  (location: { id: number }) =>
                    location.id === Number(values.locationId)
                );

                // The cutoff is only offered when the selected Work Center is
                // opted in, mirroring how flexible signups gate their row, and
                // only for a shift that is actually being posted.
                if (
                  (isShiftSwap && !isShiftCoverage) ||
                  !selectedWorkcenter?.isShiftAcceptanceCutoffEnabled
                ) {
                  return null;
                }

                const inheritedCutoffHours =
                  selectedLocation?.shiftAcceptanceCutoffMinHours ?? null;

                const cutoffHours =
                  values.minHoursBeforeShiftStartToAccept ||
                  inheritedCutoffHours ||
                  DEFAULT_CUTOFF_HOURS;

                const acceptUntil = values.isShiftAcceptanceCutoffEnabled
                  ? getAcceptanceCutoffTime(values.startTime, cutoffHours)
                  : null;

                return (
                  <Box width="100%" mt={2}>
                    <Box display="flex" alignItems="flex-start">
                      <Toggle
                        name="isShiftAcceptanceCutoffEnabled"
                        id="isShiftAcceptanceCutoffEnabled"
                        checked={values.isShiftAcceptanceCutoffEnabled}
                        onChange={() => {
                          acceptanceCutoffTouchedRef.current = true;
                          const enabling =
                            !values.isShiftAcceptanceCutoffEnabled;
                          setValues({
                            ...values,
                            isShiftAcceptanceCutoffEnabled: enabling,
                            // Keep the last value on disable so re-enabling
                            // restores it, same as the flexible signup rows.
                            minHoursBeforeShiftStartToAccept: enabling
                              ? values.minHoursBeforeShiftStartToAccept ||
                                inheritedCutoffHours ||
                                DEFAULT_CUTOFF_HOURS
                              : values.minHoursBeforeShiftStartToAccept,
                          });
                          setTimeout(() => validateForm(), 0);
                        }}
                      />
                      <Box display="flex" flexDirection="column" ml={2}>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            letterSpacing: "0.15px",
                            color: "#000000DE",
                          }}
                        >
                          {t("scheduler_acceptance-cutoff")}
                        </Typography>
                      </Box>
                    </Box>

                    {values.isShiftAcceptanceCutoffEnabled ? (
                      <Box
                        ml={6}
                        mt={2}
                        sx={{
                          backgroundColor: "#F4F7FE",
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          p: 1.5,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#000000DE",
                          }}
                        >
                          {t("scheduler_acceptance-cutoff-label")}
                        </Typography>
                        <Box mt={1}>
                          <CutoffHoursInput
                            value={cutoffHours}
                            onChange={(hours) => {
                              acceptanceCutoffTouchedRef.current = true;
                              setFieldValue("minHoursBeforeShiftStartToAccept", hours);
                            }}
                          />
                        </Box>
                        <Typography
                          sx={{ fontSize: "12px", color: "#00000099", mt: 1 }}
                        >
                          {t("scheduler_acceptance-cutoff-hint")}
                        </Typography>
                        {errors.minHoursBeforeShiftStartToAccept ? (
                          <Typography
                            sx={{
                              fontSize: "12px",
                              color: colors.error,
                              mt: 1,
                            }}
                          >
                            {errors.minHoursBeforeShiftStartToAccept}
                          </Typography>
                        ) : null}
                        {acceptUntil ? (
                          <Box
                            display="flex"
                            alignItems="center"
                            gap={0.5}
                            mt={1}
                          >
                            <EventAvailableOutlinedIcon
                              sx={{ fontSize: "16px", color: "#0000008f" }}
                            />
                            <Typography
                              sx={{ fontSize: "14px", color: "#000000DE" }}
                            >
                              {t("scheduler_acceptance-cutoff-until", {
                                time: format(acceptUntil, "h:mm a, EEE MMM d", {
                                  locale: dateLocale,
                                }),
                              })}
                            </Typography>
                          </Box>
                        ) : null}
                        {inheritedCutoffHours &&
                        cutoffHours !== inheritedCutoffHours ? (
                          <Typography
                            sx={{ fontSize: "12px", color: "#00000099", mt: 1 }}
                          >
                            {t("scheduler_acceptance-cutoff-override", {
                              hhmm: formatCutoffHours(inheritedCutoffHours),
                            })}
                          </Typography>
                        ) : null}
                      </Box>
                    ) : inheritedCutoffHours ? (
                      <Box
                        ml={6}
                        mt={2}
                        display="flex"
                        gap={1}
                        sx={{
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          p: 1.5,
                        }}
                      >
                        <TimerOutlinedIcon
                          sx={{
                            fontSize: "18px",
                            color: "rgba(0,0,0,0.56)",
                          }}
                        />
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "rgba(0,0,0,0.87)",
                            }}
                          >
                            {t("scheduler_acceptance-cutoff-opted-out", {
                              hhmm: formatCutoffHours(inheritedCutoffHours),
                            })}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              color: "rgba(0,0,0,0.6)",
                            }}
                          >
                            {t("scheduler_acceptance-cutoff-inherited-none")}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Typography
                        ml={6}
                        mt={1}
                        sx={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}
                      >
                        {t("scheduler_acceptance-cutoff-inherited-none")}
                      </Typography>
                    )}
                  </Box>
                );
              })()}

              {!isShiftSwap ? (
                <Box width="100%" mt={3} mb={3}>
                  <Box width="30%" display="flex" alignItems="center">
                    <FilledFormControl
                      customStyles={{ width: "30% !important" }}
                    >
                      <Toggle
                        name="repeatShift"
                        id="repeatShift"
                        //type='checkbox'
                        onChange={() =>
                          setFieldValue("repeatShift", !values.repeatShift)
                        }
                      />
                    </FilledFormControl>

                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "16px",
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        letterSpacing: "0.15px",
                      }}
                    >
                      {t("scheduler_repeat-shift")}
                    </Typography>
                  </Box>
                </Box>
              ) : null}

              {!isShiftSwap && values.repeatShift ? (
                <RepeatShift
                  values={values}
                  setFieldValue={setFieldValue}
                  selectedDatesOfTheWeek={selectedDatesOfTheWeek}
                  width={width}
                />
              ) : null}

              {!isShiftSwap && values.repeatShift ? (
                <RepeatShiftHolidayAlert
                  preview={repeatHolidayPreview}
                  isSkipping={!!values.skipHolidayDates}
                  setFieldValue={setFieldValue}
                />
              ) : null}

              {isShiftSwap && (
                <Box
                  sx={{
                    height: "172px",
                  }}
                />
              )}
            </Box>
            {/* Create Button */}
            <Box
              sx={{
                borderTop: "1px solid #E0E0E0",
                padding: "20px 45px",
                backgroundColor: "#fff",
                position: "sticky",
                bottom: 0,
                zIndex: 1100,
              }}
            >
              {isShiftSwap && !isShiftCoverage ? (
                <Approve
                  handleClose={handleClose}
                  toDecline={
                    workerRequestMetaData.requestStatusCode === "a" ||
                    workerRequestMetaData.requestStatusCode === "aa"
                  }
                  isPending={workerRequestMetaData.requestStatusCode === "p"}
                />
              ) : (
                <ActionButtons
                  handleClose={() => {
                    handleClose && handleClose();
                    dispatch(resetMaxWorkersByLocationJob());
                  }}
                  isValid={isValid}
                  dirty={dirty}
                  isSubmitting={isSubmitting}
                  isShiftSwap={isShiftSwap}
                  decisionCode={formData?.decisionCode}
                  requestStatusCode={workerRequestMetaData?.requestStatusCode}
                  isDisabled={
                    // Check if skills/job requirements are met
                    (shiftType === "skills" &&
                      values.shiftSkills.length === 0) ||
                    (shiftType !== "skills" && !values.jobId) ||
                    // Check shift purpose if enabled
                    (isShiftPurposeEnabled && !values.shiftPurposeId) ||
                    // Check the free-text detail the shift purpose asks for
                    (isShiftPurposeEnabled &&
                      !!shiftPurposeDetailField?.isRequired &&
                      !values.shiftPurposeDetail?.trim()) ||
                    // Check repeat shift settings
                    (values.repeatShift &&
                      !Object.values(values.repeatOn).some(Boolean)) ||
                    // Every repeat is a holiday and they are being skipped
                    (values.repeatShift &&
                      !!repeatHolidayPreview?.isNothingToCreate)
                  }
                  jobSelected={!!values.jobId}
                  skillSelected={!!values.shiftSkills.length}
                  availableWorkers={maxWorkersByJobLocation.data ?? 0}
                />
              )}
            </Box>
          </Form>
        );}}
      </Formik>
      {createDraftShiftAsyncStatus === "error" && (
        <Snackbar
          open={createDraftShiftAsyncStatus === "error"}
          autoHideDuration={1000}
          onClose={() => {
            try {
              dispatch(resetCreateDraftShiftAsyncState());
            } catch (e) {
              // Do nothing
            }
          }}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert elevation={6} variant="filled" severity="error">
            {createDraftShiftAsyncErrorMessage}
          </MuiAlert>
        </Snackbar>
      )}
    </Box>
  );
};

export default React.memo(NewShiftDialogForm);
